import invariant from 'invariant';
import { isUUID } from '@frameio/utils/formatters';
import { createUrl } from '../helpers/createUrl';
import { getPathnameFromHref } from '../helpers/getPathnameFromHref';
import type { ValidHref } from '../types';

// @todo (WEB-1045): Add condensed UUID support to routes
// import { toCondensedUUID } from '@frameio/utils/formatters/uuid';

// @todo (WEB-1045): Remove when condensed UUID support is added to routes
const toCondensedUUID = (uuid: string): string => uuid;

export type ProjectGetLinkParams = {
  page: 'project';
  projectId: string;
};

export const getLinkForProject = (params: ProjectGetLinkParams): ValidHref => {
  invariant(params.projectId, 'projectId is required');

  const _projectId = toCondensedUUID(params.projectId);

  return createUrl({
    pathname: `/project/${_projectId}`,
  });
};

export const isProjectPageType = (href: ValidHref | string): boolean => {
  const pathname = getPathnameFromHref(href);
  const parts = pathname.split('/');

  return parts.length >= 3 && parts[1] === 'project' && isUUID(parts[2]);
};

export const getProjectIdFromPath = (
  href: ValidHref | string
): string | null => {
  if (!isProjectPageType(href)) {
    return null;
  }
  return href.split('/')[2];
};
